/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TotalEmissionEstimate } from "./TotalEmissionEstimate";
import {
    TotalEmissionEstimateFromJSON,
    TotalEmissionEstimateFromJSONTyped,
    TotalEmissionEstimateToJSON,
} from "./TotalEmissionEstimate";

/**
 *
 * @export
 * @interface TotalEmissionEstimateResponse
 */
export interface TotalEmissionEstimateResponse {
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimateResponse
     */
    dayCount?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimateResponse
     */
    deviceCount?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimateResponse
     */
    totalEmissionKg?: number;
    /**
     * Percentage difference in total emissions (based on TotalEmissionKg) from the previous period, can be null if previous period does not have data.
     * @type {number}
     * @memberof TotalEmissionEstimateResponse
     */
    totalDiffPercentage?: number;
    /**
     *
     * @type {Array<TotalEmissionEstimate>}
     * @memberof TotalEmissionEstimateResponse
     */
    items?: Array<TotalEmissionEstimate>;
}

/**
 * Check if a given object implements the TotalEmissionEstimateResponse interface.
 */
export function instanceOfTotalEmissionEstimateResponse(
    value: object,
): value is TotalEmissionEstimateResponse {
    return true;
}

export function TotalEmissionEstimateResponseFromJSON(
    json: any,
): TotalEmissionEstimateResponse {
    return TotalEmissionEstimateResponseFromJSONTyped(json, false);
}

export function TotalEmissionEstimateResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TotalEmissionEstimateResponse {
    if (json == null) {
        return json;
    }
    return {
        dayCount: json["dayCount"] == null ? undefined : json["dayCount"],
        deviceCount:
            json["deviceCount"] == null ? undefined : json["deviceCount"],
        totalEmissionKg:
            json["totalEmissionKg"] == null
                ? undefined
                : json["totalEmissionKg"],
        totalDiffPercentage:
            json["totalDiffPercentage"] == null
                ? undefined
                : json["totalDiffPercentage"],
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      TotalEmissionEstimateFromJSON,
                  ),
    };
}

export function TotalEmissionEstimateResponseToJSON(
    value?: TotalEmissionEstimateResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        dayCount: value["dayCount"],
        deviceCount: value["deviceCount"],
        totalEmissionKg: value["totalEmissionKg"],
        totalDiffPercentage: value["totalDiffPercentage"],
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      TotalEmissionEstimateToJSON,
                  ),
    };
}
